
import Vue from 'vue'
import {
  VCard,
  VCardActions,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VSkeletonLoader,
} from 'vuetify/lib'

export default Vue.extend({
  components: {
    VCard,
    VCardTitle,
    VCardSubtitle,
    VCardActions,
    VCardText,
    VSkeletonLoader,
  },
  props: {
    imgPadding: { type: Boolean, default: false },
    actionBgColor: { type: String, default: '' },
    path: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      name: 'JcdcCards',
    }
  },
  methods: {
    hasSlot(name: string): boolean {
      return Boolean(this.$slots[name])
    },
  },
})
